import React from 'react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { FAQ } from '@/constants/testIds';

export const FaqAccordion = ({ items }) => {
  const { t } = useTranslation();
  const list = items || t('faqs', { returnObjects: true });
  return (
    <Accordion data-testid={FAQ.section} type="single" collapsible className="space-y-3">
      {list.map((item, i) => (
        <AccordionItem
          key={i}
          value={`item-${i}`}
          data-testid={`faq-item-${i}`}
          className="group overflow-hidden rounded-2xl border border-white/10 bg-[#001826]/70 px-5 !border-b transition-colors hover:border-brand/25 data-[state=open]:border-brand/40 data-[state=open]:bg-[#001826]"
        >
          <AccordionTrigger className="gap-4 py-5 text-left text-[15px] font-semibold text-white hover:no-underline [&>svg]:hidden">
            {item.q}
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-white/15 text-white/60 transition-all duration-300 group-hover:border-brand/40 group-hover:text-brand group-data-[state=open]:rotate-45 group-data-[state=open]:border-brand group-data-[state=open]:bg-brand group-data-[state=open]:text-black">
              <Plus className="h-4 w-4" />
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-5 pr-10 text-sm leading-relaxed text-white/60">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
